/**
 * @generated SignedSource<<83960a6e7771dee7e949f001e06a340e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraSprintState = "ACTIVE" | "CLOSED" | "FUTURE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type groupRow_issueTableGrouping_groupRow$data = {
  readonly fieldId: string | null | undefined;
  readonly fieldType: string | null | undefined;
  readonly fieldValue: {
    readonly __typename: "JiraJqlGoalsFieldValue";
    readonly goal: {
      readonly id: string;
    };
  } | {
    readonly __typename: "JiraJqlNumberFieldValue";
    readonly number: number | null | undefined;
  } | {
    readonly __typename: "JiraJqlOptionFieldValue";
    readonly option: {
      readonly color: {
        readonly colorKey: string | null | undefined;
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly id: string;
      readonly optionId: string;
      readonly value: string | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "JiraJqlPriorityFieldValue";
    readonly priority: {
      readonly iconUrl: AGG$URL | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly priorityId: string;
    };
  } | {
    readonly __typename: "JiraJqlSprintFieldValue";
    readonly sprint: {
      readonly endDate: AGG$DateTime | null | undefined;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly sprintId: string;
      readonly state: JiraSprintState | null | undefined;
    };
  } | {
    readonly __typename: "JiraJqlStatusFieldValue";
    readonly status: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly statusCategory: {
        readonly id: string;
        readonly statusCategoryId: string;
      } | null | undefined;
    } | null | undefined;
  } | {
    readonly __typename: "JiraJqlUserFieldValue";
    readonly user: {
      readonly accountId: string;
      readonly id: string;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
  readonly id: string;
  readonly jql: string;
  readonly " $fragmentSpreads": FragmentRefs<"groupHeader_issueTableGrouping">;
  readonly " $fragmentType": "groupRow_issueTableGrouping_groupRow";
};
export type groupRow_issueTableGrouping_groupRow$key = {
  readonly " $data"?: groupRow_issueTableGrouping_groupRow$data;
  readonly " $fragmentSpreads": FragmentRefs<"groupRow_issueTableGrouping_groupRow">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "groupRow_issueTableGrouping_groupRow",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "jql"
      },
      "action": "THROW",
      "path": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "fieldType"
    },
    {
      "kind": "LinkedField",
      "name": "fieldValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__typename"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraPriority",
              "kind": "LinkedField",
              "name": "priority",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "priorityId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "iconUrl"
                }
              ]
            }
          ],
          "type": "JiraJqlPriorityFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "accountId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "picture"
                }
              ]
            }
          ],
          "type": "JiraJqlUserFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraStatus",
              "kind": "LinkedField",
              "name": "status",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "concreteType": "JiraStatusCategory",
                  "kind": "LinkedField",
                  "name": "statusCategory",
                  "plural": false,
                  "selections": [
                    (v0/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "statusCategoryId"
                    }
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlStatusFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ],
          "type": "JiraJqlNumberFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraOption",
              "kind": "LinkedField",
              "name": "option",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "optionId"
                },
                {
                  "kind": "ScalarField",
                  "name": "value"
                },
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "color",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    },
                    (v0/*: any*/)
                  ]
                }
              ]
            }
          ],
          "type": "JiraJqlOptionFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraSprint",
              "kind": "LinkedField",
              "name": "sprint",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "sprintId"
                },
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "state"
                },
                {
                  "kind": "ScalarField",
                  "name": "endDate"
                }
              ]
            }
          ],
          "type": "JiraJqlSprintFieldValue"
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "concreteType": "JiraGoal",
              "kind": "LinkedField",
              "name": "goal",
              "plural": false,
              "selections": [
                (v0/*: any*/)
              ]
            }
          ],
          "type": "JiraJqlGoalsFieldValue"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "groupHeader_issueTableGrouping"
    }
  ],
  "type": "JiraSpreadsheetGroup"
};
})();

(node as any).hash = "59d6ca2176af6cfc4715541c7e23edd9";

export default node;
